'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotSunburstIcon = function PlotSunburstIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 14.57 14.6' }, props),
        _react2.default.createElement('circle', { cx: '7.25', cy: '7.19', r: '1.22' }),
        _react2.default.createElement('path', { d: 'M7.19 10.03a2.85 2.85 0 1 1 2.85-2.85 2.85 2.85 0 0 1-2.85 2.85zm0-4.86a2 2 0 1 0 2 2 2 2 0 0 0-2-1.96zM3.8.87a7.35 7.35 0 0 0-3 3.08c-.08.18-.18.37-.21.44l-.06.12 1.79.68c1 .37 1.8.67 1.81.66a1.61 1.61 0 0 0 .14-.24 3.77 3.77 0 0 1 1.22-1.26l.16-.1-.79-1.76-.8-1.76h-.08z' }),
        _react2.default.createElement('path', { d: 'M5.32 2.28l.8 1.75.24-.07a3.74 3.74 0 0 1 1.12-.12 3.54 3.54 0 0 1 2.5 1.29 2.43 2.43 0 0 1 .42.74 2.73 2.73 0 0 1 .28.78 3.61 3.61 0 0 1 0 1.43v.22l1.78.68c1 .37 1.79.66 1.81.65a7.57 7.57 0 0 0 .29-1.12 7.43 7.43 0 0 0-.37-3.55 9.33 9.33 0 0 0-.78-1.62A7.37 7.37 0 0 0 9.87.47 7.25 7.25 0 0 0 7.54.03a7.44 7.44 0 0 0-2.83.44l-.18.07zM.31 5.18a7.48 7.48 0 0 0-.12 3.65 7.94 7.94 0 0 0 1.3 2.85 6.11 6.11 0 0 0 1.27 1.28s.54-.69 1.17-1.52l1.12-1.51-.19-.19a2.89 2.89 0 0 1-.69-1 3.4 3.4 0 0 1-.26-2.15v-.25l-1.72-.68-1.82-.63zM4.3 11.75c-.7.91-1.11 1.53-1.11 1.55a5.52 5.52 0 0 0 .85.52 7.41 7.41 0 0 0 2.93.77 6.39 6.39 0 0 0 1.11 0s-.11-.86-.25-1.9l-.25-1.9h-.39a3.4 3.4 0 0 1-1.54-.42l-.19-.1zM10.26 9.03l-.07.21h.08l1.81.7 1.73.66.08-.22.08-.21-1.78-.69-1.81-.68z' })
    );
};

exports.default = PlotSunburstIcon;